import { Button, Col, message, Row, Segmented, Table, Tag } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { useNavigate } from "react-router-dom";
import restful from "../../restful";

interface DataType {
    status: string,
    method: string,
    time: string,
    url: string,
    body: string,
    query: string,
    _id: string,
    createdAt: string,
    updatedAt: string
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string, client: string | number }

const RequestLogsTable: FC = () => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [client, setClient] = useState<string | number>('app')
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });

    const columns: ColumnsType<DataType> = [
      
        {
            sorter: true, title: 'هدر',ellipsis: true, dataIndex: 'headers', key: 'headers',
            render(val: string) {
                return <div style={{ direction: "ltr", textAlign: "left" }}>{val}</div>
            },
        },
        {
            sorter: true, title: 'بدنه', dataIndex: 'body', key: 'body',ellipsis: true,
            render(val: string) {
                return <div style={{ direction: "ltr", textAlign: "left" }}>{val}</div>
            },
        },
        {
            sorter: true, ellipsis: true, title: 'کوئری استرینگ', dataIndex: 'query', key: 'query',
            render(val: string) {
                return <div style={{ direction: "ltr", textAlign: "left" }}>{val}</div>
            },
        },

        {
            sorter: true, ellipsis: true, title: 'آدرس', dataIndex: 'url', key: 'url',
            render(val: string) {
                return <div style={{ direction: "ltr", textAlign: "left" }}>{val}</div>
            },
        },

        {
            sorter: true, title: 'متد', dataIndex: 'method', key: 'method', width: 80,
            render(val: string) {
                return <div style={{ direction: "ltr", textAlign: "left" }}>{val}</div>
            },
        },
        {
            sorter: true, title: 'زمان', dataIndex: 'time', key: 'time', width: 100,
            render(val: string) {
                return <div style={{ direction: "ltr", textAlign: "left" }}>{val}</div>
            },
        },

        {
            sorter: true, title: 'وضعیت', dataIndex: 'status', key: 'status', width: 100,
            render(val: string) {
                if (val.substring(0, 1) == "2") return <Tag color="green">{val}</Tag>
                if (val.substring(0, 1) == "3") return <Tag color="gold">{val}</Tag>
                if (val.substring(0, 1) == "4") return <Tag color="red">{val}</Tag>
                return <Tag>{val}</Tag>
            },
        },

        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'زمان درخواست', dataIndex: 'createdAt', key: 'createdAt', width: 180,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },

    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        restful.get(`/request-logs/paginate`, { params })
            .then((res) => {
                const result = res.data.result
                setItems(result.requestLogs);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.requestLogsCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({
            sortDir: "desc", sort: "createdAt", client,
            page: pagination.current, perPage: pagination.pageSize
        });
    }, [client])

    function resetData() {
        fetchData({
            sortDir: "desc", sort: "createdAt", client,
            page: pagination.current, perPage: pagination.pageSize
        });
    }
    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current, client,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "createdAt"
        });
    };

    return <>
        <Row gutter={[16, 16]} style={{ padding: "16px 0" }}>
            <Col flex="auto" >
                <Segmented options={['admin', 'app', "other"]} value={client} onChange={setClient} />
            </Col>
            <Col flex="none"><Button onClick={() => resetData()} >تازه سازی</Button></Col>
        </Row>

        <Table
            columns={columns}
            dataSource={items}
            loading={isLoaded}
            rowKey="_id"
            pagination={pagination}
            onChange={handleTableChange}
        />
    </>
}

export default RequestLogsTable


